import { createSelector } from "@ngrx/store";
import { IFinantialExpensesReportState } from "./finantial-expenses-report.reducer";

const finantialExpensesReportStore = (state: any) => state.finantialExpensesReport as IFinantialExpensesReportState;

export const selectFinantialExpensesReport = createSelector(
    finantialExpensesReportStore,
    (state) => state.finantial_expenses_report
);